import { render, staticRenderFns } from "./TrolleyMenu.vue?vue&type=template&id=17e63537&scoped=true"
import script from "./TrolleyMenu.vue?vue&type=script&lang=js"
export * from "./TrolleyMenu.vue?vue&type=script&lang=js"
import style0 from "./TrolleyMenu.vue?vue&type=style&index=0&id=17e63537&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e63537",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
